module.exports = __webpack_public_path__ + "static/media/skylar.74f97702.png";